import getPDFHeader from './PDFHeader';

export const pdfInitConfig = {
  exporterType: 'multipage',
  fileName: 'Plataine-scheduler',
  fileFormat: 'pdf',
  orientation: 'landscape',
  scheduleRange: 'currentview',
  repeatHeader: true,
  headerTpl: getPDFHeader,
};
